<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="400px"
        overlay-color="#909090"
        overlay-opacity="1"
    >

        <edit-profile
            v-if="additionalFields.length"
            :fields="additionalFields"
            @proceed="proceed"
            @cancel="decline"
        />
        <v-card v-else>
            <div class="text-right" v-if="!showExitConfirmation">
                <v-btn icon color="primary" @click="showExitConfirmation = true">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <welcome-screen
                v-if="!showExitConfirmation"
                @loading="loading = true"
                @loaded="loading = false"
                @manuallyCreateAccount="manuallyCreateAccount"
                @proceed="proceed"
            />
            <exit-confirmation
                v-if="showExitConfirmation"
                @continue="showExitConfirmation = false"
                @exit="decline"
            />
        </v-card>
        <loading-overlay :loading="loading" />
    </v-dialog>
</template>

<script>
import FormFillerService from '../../../services/FormFillerService';
import WelcomeScreen from './welcome-screen.vue';
import ExitConfirmation from './exit-confirmation.vue';
import EditProfile from './edit-profile.vue';
import SmsVerification from './sms-verification.vue';

export default {
    components: {
        WelcomeScreen,
        ExitConfirmation,
        EditProfile,
        SmsVerification,
    },
    data() {
        return {
            showDialog: false,
            loading: false,
            resolve: () => {},
            step: 1,
            showExitConfirmation: false,
            additionalFields: [],
        }
    },
    methods: {
        confirm() {
            this.showDialog = true;
            this.showExitConfirmation = false;
            this.additionalFields = [];

            return new Promise((resolve) => {
                this.resolve = resolve;
                // this.reject = reject;
            });
        },
        async handleError() {
            const { value } = await this.$swal({
                type: 'error',
                title: 'Oops! Our Connection is Down',
                html: `We sincerely apologize about this issue and are currently looking
                    into it. To proceed, click the "Continue" button below to proceed to
                    make payment manually. Alternatively, you may try again later.
                    Thank you`,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            });

            if (value) {
                this.manuallyCreateAccount();
                return false;
            }

            this.decline();

        },
        async proceed(payload = {}) {
            const {
                kaoshi_email: email,
            } = this.$store.state.user;

            let password = await this.fetchPassword(email);
            if (!password) {
                password = await this.generatePassword();
            }

            const registrationSuccess = await this.register(password, payload);
            if (!registrationSuccess) {
                return;
            }

            this.showDialog = false;
            this.resolve({
                accountCreated: true,
            });
        },
        async register(password, payload = {}) {
            try {
                this.loading = true;
                const { data } = await Vue.backendApi().worldremit()
                    .register({
                        ...payload,
                        password,
                    });
                this.loading = false;

                if (data.fields) {
                    this.additionalFields = data.fields;
                    return false;
                }

                this.additionalFields = [];
                return true;
            } catch (err) {
                console.log('register err catch', err);

                if (err.toLowerCase().indexOf('exists') >= 0) {
                    this.showDialog = false;
                    this.resolve({
                        alreadyExists: true,
                        email: this.$store.state.user.kaoshi_email,
                    });

                    this.$swal({
                        type: 'error',
                        title: 'User with such email already exists, please log in',
                    });
                    return false;
                }

                this.loading = false;
                this.handleError(err);
                throw err;
            }
        },
        async fetchPassword(email) {
            try {
                this.loading = true;
                const password = await FormFillerService.fetchPassword(email, 'www.worldremit.com');
                this.loading = false;
                return password;
            } catch (err) {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Something wrong',
                    text: err
                });
                throw err;
            }
        },
        async generatePassword() {
            try {
                this.loading = true;
                const password = await FormFillerService.generatePassword('www.worldremit.com');
                this.loading = false;
                return password;
            } catch (err) {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Something wrong',
                    text: err
                });
                throw err;
            }
        },
        manuallyCreateAccount() {
            this.showDialog = false;
            this.resolve({
                createAccountManually: true,
            });
        },
        decline() {
            this.showDialog = false;
            this.resolve({
                declined: true,
            });
        },
    },
};
</script>
